import Text from '@/components/atoms/Text';
import * as S from './styles';
import { PlanoProduto } from '@/types/produto';
import formatarMoeda from '@/utils/formatarMoeda';

export type GiftCardProps = {
  $selecionado: boolean;
  $giftCard: PlanoProduto;
  $onClick: () => void;
};

export default function GiftCard(props: GiftCardProps) {
  const { $selecionado, $giftCard, $onClick } = props;
  return (
    <S.Container $selecionado={$selecionado} onClick={$onClick}>
      <Text
        $size={3}
        $color="neutral"
        $weight="regular"
        $align="center"
        $highContrast={true}
        $text={$giftCard.nome}
      />
      <Text
        $size={3}
        $color="neutral"
        $weight="bold"
        $align="center"
        $highContrast={true}
        $text={formatarMoeda({
          valor: $giftCard.preco,
        })}
      />
    </S.Container>
  );
}
